<div class="form-group">
  <label for="prod-m">{{ 'form.language'| translate }}</label>
  <angular2-multiselect [data]="languagesList"
      [(ngModel)]="languageSelected"
      [settings]="multiselectSettings[EMULTI_SELECT_SETTING.NO_SEARCH]"
      (onSelect)="onLanguageSelect()">
  </angular2-multiselect>
</div>
